module.exports = __webpack_public_path__ + "img/sprite.45c8ab8f.svg";